import { render, staticRenderFns } from "./ApiManagementView.vue?vue&type=template&id=cfcd3016&"
import script from "./ApiManagementView.vue?vue&type=script&lang=ts&"
export * from "./ApiManagementView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ApiManagementView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports